<template>
    <!-- Aba de Cálculos -->
    <div class="tab-pane fade show active" id="ellipsoidalHeadPressConcaveCalculator">
        
        <!-- BOTÃO DESENHO DE APOIO -->
        <h5 class="text mt-5 text-primary">
            <b>Desenho de apoio</b>
        </h5>
        <div class="col-2">
            <button
            class="btn btn-secundario"
            @click="mostrarDesenho()"
            >
            Mostrar desenho
            </button>
        </div>
        <!-- POPUP COM O DESENHO -->
        <DesenhoApoio
        v-model="showDrawing"
        :tipo="4"
        />

        <h5 class="text mt-5 text-primary"><b>ELLIPSOIDAL HEADS UNDER PRESSURE ON CONCAVE SIDE ACCORDING TO ASME VIII DIV.1 (UG - 32). MANDATORY APPENDIX 1.
		</b></h5>

        <form ref="formCalculo" @submit.prevent="calculos">
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>1. DESIGN DATA</b></h5>
                </div>
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>SYMBOLS USED IN THE FORMULAS AND DRAWING	</b></h5>
                </div>
            </div>

            <div class="table-responsive material-table">
                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">DESIGN DATA</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <span><b>Material Specification <br>(ASME II part D)</b></span>
                                <InterrogacaoHover text="Busca do material conforme ASME Section II Part D. A seleção define propriedades mecânicas como tensão admissível (Sh/Sc), limites de temperatura e parâmetros utilizados no dimensionamento do tampo elipsoidal." />
                            </th>
                            <td>
                                <!-- Container com posição relativa para conter a lista -->
                                <div class="position-relative">
                                    <!-- BUSCA -->
                                    <div class="position-relative">
                                        <input
                                        type="search"
                                        class="form-control ps-5 input"
                                        placeholder="Buscar material"
                                        v-model="materialSearch"

                                        @focus="abrirListaMaterial"
                                        @click="abrirListaMaterial"
                                        @input="handleInput"
                                        @blur="fecharListaMaterial"
                                        required
                                        />

                                        <!-- ÍCONE LUPA -->
                                        <span
                                            class="position-absolute start-0 top-50 translate-middle-y ps-3"
                                        >
                                            <img src="@/views/img/search-icon.svg" width="16" />
                                        </span>
                                    </div>

                                    <!-- LISTA DE RESULTADOS - Agora dentro do container position-relative -->
                                    <ul
                                        v-if="mostrarListaMaterial && materiaisFiltrados.length"
                                        class="material-options list-group position-absolute w-100 mt-1"
                                    >
                                        <li
                                            class="material-option list-group-item list-group-item-action"
                                            v-for="(material, index) in materiaisFiltrados"
                                            :key="material.materialSpecification + index"
                                            @mousedown.prevent="selecionarMaterial(material)"
                                        >
                                            <b>{{ [material.materialSpecification, material.classConditionTemper].filter(Boolean).join(" ") }}</b>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Nominal Composition</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.nominalComposition }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Product Form</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.productForm }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Alloy Designation/UNS No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.alloyDesignation }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Class/Condition/Temper</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.classConditionTemper }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">P-No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.pNo }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Group No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.groupNo }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Min. Tensile Strength</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.minTensileStrength }}
                                </h6>
                            </td>
                            <td> </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Min. Yield Strength</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.minYieldStrength }}
                                </h6>
                            </td>
                            <td> </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">VIII-1—Applic, and Max, Temp, Limit (°C)</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.viiiApplicAndMaxTemLimit }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Design Temperature</th>
                            <td>DT</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.designTemperature }}
                                </h6>
                            </td>
                            <td>°C</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Inside Diameter</b></span>
                                <InterrogacaoHover text="Diâmetro interno do vaso ou tampo elipsoidal. Parâmetro fundamental para cálculo da espessura mínima sob pressão interna, conforme ASME VIII Div.1." />
                            </th>
                            <td><b>Di</b></td>
                            <td>
                                <input type="number" step="any" class="form-control" v-model="ellipsoidalHeadPressConcaveCalculator.insideDiameter" required/>
                            </td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Liquid Column</b></span>
                                <InterrogacaoHover text="Altura da coluna de fluido acima do tampo. Utilizada para cálculo da pressão hidrostática adicional atuando na região analisada." />
                            </th>
                            <td><b>H</b></td>
                            <td>
                                <input type="number" step="any" class="form-control" v-model="ellipsoidalHeadPressConcaveCalculator.liquidColumn" 
                                :disabled="posicao === 'Cima' || designDataPosition === 'Horizontal'" required/>
                            </td>
                            <td><b>m</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Depth (See in drawing)</b></span>
                                <InterrogacaoHover text="Profundidade do tampo elipsoidal (h), conforme indicado no desenho. Esse parâmetro define a geometria do tampo e influencia diretamente o fator K (D/2h) utilizado no dimensionamento." />
                            </th>
                            <td><b>h</b></td>
                            <td>
                                <input type="number" step="any" class="form-control" v-model="ellipsoidalHeadPressConcaveCalculator.length" required/>
                            </td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Depth (See in drawing) Corroded</th>
                            <td>hc</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ this.converterParaFloat(ellipsoidalHeadPressConcaveCalculator.lengthCorroded).toFixed(2) }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Fluid Density</th>
                            <td>-</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.fluidDensity }}
                                </h6>
                            </td>
                            <td>kg/m³</td>
                        </tr>
                        <tr>
                            <th scope="row">Design Pressure on the Top of the Vessel</th>
                            <td>Pint</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.designPressureTop }} 
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Design Pressure</th>
                            <td>P</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.designPressure }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Admissible Stress @ Design Temperature</th>
                            <td>Sh</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Admissible Stress @ Room Temperature</th>
                            <td>Sc</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.admissibleStressRoomTemp }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Inside Radius</th>
                            <td>Ri</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.insideRadius }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Inside Radius Corroded</th>
                            <td>Ric</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.insideRadiusCorroded }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Factor for Ellipsiodal Heads (D/2h)</th>
                            <td>K</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.factorForEllipsiodalHeads }}
                                </h6>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row">Corrosion Allowance</th>
                            <td>CA</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.corrosionAllowance }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Nominal Thickness minus Corrosion Allowance</th>
                            <td>CA</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Welded Joint Efficiency</b></span>
                                <InterrogacaoHover text="Eficiência da junta soldada (E). Representa a qualidade da soldagem conforme o nível de inspeção (radiografia total, parcial ou sem inspeção), afetando diretamente a espessura requerida." />
                            </th>
                            <td><b>-</b></td>
                            <td>
                                <select class="form-select" v-model="ellipsoidalHeadPressConcaveCalculator.weldedJointEfficiency" required>
                                    <option value="" selected>Selecione</option>
                                    <option value="1.00">1.00</option>
                                    <option value="0.90">0.90</option>
                                    <option value="0.85">0.85</option>
                                    <option value="0.80">0.80</option>
                                    <option value="0.70">0.70</option>
                                    <option value="0.65">0.65</option>
                                    <option value="0.60">0.60</option>
                                </select>
                            </td>
                            <td><b>--</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Nominal Thickness</b></span>
                                <InterrogacaoHover text="Espessura nominal selecionada para o tampo elipsoidal. Deve ser igual ou superior à espessura mínima calculada, considerando corrosão, tolerâncias de fabricação e requisitos normativos." />
                            </th>
                            <td><b>-</b></td>
                            <td>
                                <select class="form-select" v-model="ellipsoidalHeadPressConcaveCalculator.nominalThickness" required>
                                    <option value="" selected>Selecione</option>
                                    <option v-for="opcao in nominalThicknessOptions" :key="opcao" :value="opcao">
                                        {{ opcao }}
                                    </option>
                                </select>
                            </td>
                            <td><b>--</b></td>
                        </tr>

                        <!-- Scroll para ver resultados -->
                        <div class="mb-5" id="calculation-results"></div>
                        
                    </tbody>
                </table>
            </div>

            <tr></tr>
            <!-- Calculation results -->
            <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3">
                <h4 class="mb-0">
                    <b>Calculation Results:</b>
                </h4>

                <span
                    v-if="ellipsoidalHeadPressConcaveCalculator.validNominalThickness"
                    class="badge bg-success fs-6 px-3 py-2"
                >
                    <b>✔ Nominal Thickness Valid</b>
                </span>

                <span
                    v-else
                    class="badge bg-danger fs-6 px-3 py-2"
                >
                    <b>✖ Nominal Thickness Not Valid</b>
                </span>
            </div>

            <div class="form-group calculator-drawing mt-3 row">
                <div class="calculator-drawing-title">Drawing</div>
                <div class="col d-flex justify-content-center">
                    <div class="calculator-drawing-frame">
                        <img src="../img/calculator-ellipsoidal-head-press-concave/drawing-ellipsoidal-head-press-concave.png" width="400px" alt="Escala de bristol" class="calculator-drawing-image">
                    </div>
                </div>
            </div>

            <!-- Design Validation -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>2. DESIGN VALIDATION</b></h5>
                </div>
                <div class="col-6">
                    <h5 class="text mt-5 text-primary" v-if="ellipsoidalHeadPressConcaveCalculator.validNominalThickness === true">
                        <b>VALID NOMINAL THICKNESS</b>
                    </h5>
                    <h5 class="text mt-5 text-danger" v-if="ellipsoidalHeadPressConcaveCalculator.validNominalThickness === false">
                        <b>INVALID NOMINAL THICKNESS</b>
                    </h5>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 40%; text-align: left;">DESIGN DATA</th>
                            <th scope="col" style="width: 20%; text-align: center;"></th>
                            <th scope="col" style="width: 20%; text-align: center;">VALUE</th>
                            <th scope="col" style="width: 20%; text-align: center;">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Design Thickness
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>LONGITUDINAL JOINTS </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-ellipsoidal-head-press-concave/design-thickness.png" width="300px" alt="Formula for Thickness">
                                    </div>
                                    <span class="badge bg-light text-dark border mt-1">
                                        O resultado considera 10% para compensar o efeito de estricção
                                    </span>
                                </div>
                            </th>
                            <td style="text-align: center;">t</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.designThickness }}
                                </h6>
                            </td>
                            
                            <td style="text-align: center;">mm</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Working Maximum Allowable Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>LONGITUDINAL JOINTS </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-ellipsoidal-head-press-concave/working-maximum-allowable-pressure.png" width="300px" alt="Formula for MAWPc">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">MAWPc</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Hydrostatic Test Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>HIDROSTATIC TEST PRESSURE </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-ellipsoidal-head-press-concave/hidrostatic-test-pressure.png" width="300px" alt="Formula for HTP">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">HTP</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.hidrostaticTestPressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Pneumatic Test Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>PNEUMATIC TEST PRESSURE </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-ellipsoidal-head-press-concave/pneumatic-test-pressure.png" width="300px" alt="Formula for PTP">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">PTP</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ ellipsoidalHeadPressConcaveCalculator.pneumaticTestPressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </form>
    </div>
</template>

<script>
import DatabaseThickPlateASTM_A20 from "@/models/database/DatabaseThickPlateASTM_A20.js";
import arrayMateriaisASMEII from "../../../../backend/src/database/asmeii/arrayMateriaisASMEII.js";
import InterrogacaoHover from "../../componentesTelas/InterrogacaoHover.vue";
import DesenhoApoio from "../../componentesTelas/DesenhoApoio.vue";

export default {
    name: "EllipsoidalHeadPressConcaveCalculatorComponent",
    props: {
        ellipsoidalHeadPressConcaveCalculatorProps: {
            type: Object,
            required: true,
        },
        designData: {
            type: Object,
            required: true,
        },
        posicao: {
            type: String,
            default: ''
        },
    },
    components: {
        InterrogacaoHover,
        DesenhoApoio
    },
    data() {
        return {
            ellipsoidalHeadPressConcaveCalculator: this.ellipsoidalHeadPressConcaveCalculatorProps,
            nominalThicknessOptions: [],
            materialSpecificationOptions: [],

            // BUSCA MATERIAL
            materialSearch: "",
            mostrarListaMaterial: false,
            debounceTimeout: null,

            // EXIBIR DESENHO DE APOIO
            showDrawing: false,
        };
    },
    watch: {
        // Verifica a posição do tampo
        posicao: {
            immediate: true,
            handler(novaPosicao) {
            if (!novaPosicao) return;

            // garante que o campo exista
            this.ellipsoidalHeadPressConcaveCalculator.posicao = novaPosicao;

            }
        },

        // Seta o valor do material no campo de busca
        'ellipsoidalHeadPressConcaveCalculator.materialSpecification': {
            immediate: true,
            deep: true,
            handler(material) {
            if (
                material &&
                typeof material === 'object' &&
                material.materialSpecification
            ) {
                this.materialSearch = material.materialSpecification;
            }
            }
        }
    },

    computed: {
        // Verifica a posição do designData
        designDataPosition() {
            if (this.designData?.position) {
                return this.designData.position;
            }
            return null;
        },

        materiaisFiltrados() {
            const termo = this.materialSearch.toLowerCase().trim();
            
            let resultados;
            
            if (!termo) {
                resultados = this.materialSpecificationOptions;
            } else {
                resultados = this.materialSpecificationOptions.filter(mat => {
                    const materialName = mat.materialSpecification?.toLowerCase() || '';
                    return materialName.includes(termo);
                });
            }
            
            // ORDENAÇÃO GARANTIDA - por materialSpecification em ordem crescente
            const resultadosOrdenados = [...resultados].sort((a, b) => {
                const nameA = (a.materialSpecification || '').toString();
                const nameB = (b.materialSpecification || '').toString();
                
                // Extrai números dos nomes para ordenação numérica apropriada
                const numMatchA = nameA.match(/\d+/g);
                const numMatchB = nameB.match(/\d+/g);
                
                // Se ambos têm números, ordena numericamente
                if (numMatchA && numMatchB) {
                    // Compara o primeiro número encontrado
                    const numA = parseInt(numMatchA[0]);
                    const numB = parseInt(numMatchB[0]);
                    
                    if (numA !== numB) {
                        return numA - numB;
                    }
                }
                
                // Fallback para ordenação alfabética com localeCompare
                return nameA.localeCompare(nameB, undefined, { 
                    numeric: true,
                    sensitivity: 'base'
                });
            });
            
            return resultadosOrdenados;
        }
    },

    mounted() {
        this.calculos();
    },
    created() {
        const database1 = new DatabaseThickPlateASTM_A20();
        this.nominalThicknessOptions = database1.nominalThickness;

        // Carrega e ORDENA os materiais em ordem crescente
        this.carregarMateriaisOrdenados();
    },

    methods: {

        // CONTROLES DO DESENHO DE APOIO
        mostrarDesenho() {
            if(this.showDrawing === false){
                this.showDrawing = true;
            }
            else{
                this.showDrawing = false;
            }            
        },

        // CONTROLE DA IMAGEM FLUTUANTE
        startDrag(e) {
            this.dragging = true
            this.offsetX = e.clientX - this.posX
            this.offsetY = e.clientY - this.posY

            document.addEventListener('mousemove', this.onDrag)
            document.addEventListener('mouseup', this.stopDrag)
        },

        onDrag(e) {
            if (!this.dragging) return
            this.posX = e.clientX - this.offsetX
            this.posY = e.clientY - this.offsetY
        },

        stopDrag() {
            this.dragging = false
            document.removeEventListener('mousemove', this.onDrag)
            document.removeEventListener('mouseup', this.stopDrag)
        },

        abrirListaMaterial() {
            this.mostrarListaMaterial = true;
        },

        fecharListaMaterial() {
            setTimeout(() => {
            this.mostrarListaMaterial = false;
            }, 150);
        },

        // Método para carregar e ordenar materiais
        carregarMateriaisOrdenados() {
            if (Array.isArray(arrayMateriaisASMEII)) {
                // Ordena os materiais pelo materialSpecification em ordem crescente
                this.materialSpecificationOptions = arrayMateriaisASMEII
                    .slice() // Cria uma cópia
                    .sort((a, b) => {
                        const materialA = a.materialSpecification || '';
                        const materialB = b.materialSpecification || '';
                        
                        // Extrai números para ordenação numérica
                        const numMatchA = materialA.match(/\d+/g);
                        const numMatchB = materialB.match(/\d+/g);
                        
                        if (numMatchA && numMatchB) {
                            const numA = parseInt(numMatchA[0]);
                            const numB = parseInt(numMatchB[0]);
                            
                            if (numA !== numB) {
                                return numA - numB;
                            }
                        }
                        
                        // Ordenação alfabética para strings sem números ou números iguais
                        return materialA.localeCompare(materialB, undefined, { 
                            numeric: true,
                            sensitivity: 'base'
                        });
                    });
                
            } else {
                console.error('arrayMateriaisASMEII não é um array válido');
                this.materialSpecificationOptions = [];
            }
        },

        // Método para lidar com input enquanto digita
        handleInput() {
            // Limpa timeout anterior
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            
            // Abre a lista imediatamente quando começa a digitar
            if (this.materialSearch.trim() !== '' && !this.mostrarListaMaterial) {
                this.mostrarListaMaterial = true;
            }
            
            // Se apagou tudo, fecha a lista
            if (this.materialSearch.trim() === '') {
                this.mostrarListaMaterial = false;
                return;
            }
            
            // Configura novo timeout para garantir que a lista fique aberta
            this.debounceTimeout = setTimeout(() => {
                if (this.materialSearch.trim() !== '') {
                    this.mostrarListaMaterial = true;
                }
            }, 100);
        },

        selecionarMaterial(material) {
            this.ellipsoidalHeadPressConcaveCalculator.materialSpecification = material;
            this.materialSearch = material.materialSpecification;
            this.mostrarListaMaterial = false;

            this.atualizarCamposMaterial();
            this.calculos();
        },

        buscarCampoAdmissibleStressDatabaseASMEII(materialSpecification, chaveGrausCelsiusBuscada) {


            if (!materialSpecification || !materialSpecification.rangeDesignTemperatureCelsius) {
                console.warn("Material ou rangeDesignTemperatureCelsius não encontrado");
                return null;
            }

            const tabela = materialSpecification.rangeDesignTemperatureCelsius;

            // 🔹 normaliza a chave buscada
            let chaveNormalizada = chaveGrausCelsiusBuscada;

            if (typeof chaveNormalizada === "string" && chaveNormalizada.includes(",")) {
                chaveNormalizada = chaveNormalizada.replace(",", ".");
            }

            const chaveBuscada = parseFloat(chaveNormalizada);


            // 🔹 se existir valor exato
            if (tabela[chaveNormalizada] !== undefined) {
                return parseFloat(tabela[chaveNormalizada]);
            }

            // 🔹 preparar temperaturas numéricas
            const temperaturasStr = Object.keys(tabela);
            const temperaturasNum = temperaturasStr
                .map(t => parseFloat(t.replace(",", ".")))
                .sort((a, b) => a - b);

            if (chaveBuscada < temperaturasNum[0] || chaveBuscada > temperaturasNum[temperaturasNum.length - 1]) {
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const temperaturaExata = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === chaveBuscada
            );

            if (temperaturaExata !== undefined) {
                return parseFloat(tabela[temperaturaExata]);
            }

            // 🔹 encontrar anterior e posterior
            const indicePosterior = temperaturasNum.findIndex(t => t > chaveBuscada);
            const indiceAnterior = indicePosterior > 0 ? indicePosterior - 1 : -1;

            if (indiceAnterior < 0 || indicePosterior === -1) {
                console.warn("Temperatura fora do range do material");
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const tempAnterior = temperaturasNum[indiceAnterior];
            const tempPosterior = temperaturasNum[indicePosterior];

            const chaveAnteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempAnterior
            );
            const chavePosteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempPosterior
            );

            const valorAnterior = parseFloat(tabela[chaveAnteriorStr]);
            const valorPosterior = parseFloat(tabela[chavePosteriorStr]);

            // 🔹 interpolação linear (mesma lógica do backend)
            const fator =
                (chaveBuscada - tempAnterior) /
                (tempPosterior - tempAnterior);

            const interpolado =
                valorAnterior + (valorPosterior - valorAnterior) * fator;

            return interpolado.toFixed(2);

            // return Number(interpolado.toFixed(3));
        },

        atualizarCamposMaterial() {
            const materialSelecionado = this.ellipsoidalHeadPressConcaveCalculator.materialSpecification;
            if (materialSelecionado) {
                this.ellipsoidalHeadPressConcaveCalculator.nominalComposition = materialSelecionado.nominalComposition || '';
                this.ellipsoidalHeadPressConcaveCalculator.productForm = materialSelecionado.productForm || '';
                this.ellipsoidalHeadPressConcaveCalculator.alloyDesignation = materialSelecionado.alloyDesignation || '';
                this.ellipsoidalHeadPressConcaveCalculator.classConditionTemper = materialSelecionado.classConditionTemper || '';
                this.ellipsoidalHeadPressConcaveCalculator.pNo = materialSelecionado.pNo || '';
                this.ellipsoidalHeadPressConcaveCalculator.groupNo = materialSelecionado.groupNo || '';
                this.ellipsoidalHeadPressConcaveCalculator.minTensileStrength = materialSelecionado.minTensileStrength || '';
                this.ellipsoidalHeadPressConcaveCalculator.minYieldStrength = materialSelecionado.minYieldStrength || '';
                this.ellipsoidalHeadPressConcaveCalculator.viiiApplicAndMaxTemLimit = materialSelecionado.viiiApplicAndMaxTemLimit || '';
                this.calculos();
            } else {
                console.warn("Material não encontrado no DatabaseASMEII");
            }
        },
        async calculos(){
            if (this.$refs.formCalculo && !this.$refs.formCalculo.reportValidity()) {
                return;
            }

            // -- PARTE 1 - DESIGN DATA -- //

            // FLUID DENSITY
            this.ellipsoidalHeadPressConcaveCalculator.fluidDensity = this.designData.density;

            // DESIGN PRESSURE ON THE TOP OF THE VESSEL
            this.ellipsoidalHeadPressConcaveCalculator.designPressureTop = this.designData.designInternalPressure;

            // DESIGN PRESSURE
            this.ellipsoidalHeadPressConcaveCalculator.designPressure = ((this.ellipsoidalHeadPressConcaveCalculator.liquidColumn * this.ellipsoidalHeadPressConcaveCalculator.fluidDensity * 9.81) / 1000000) + this.ellipsoidalHeadPressConcaveCalculator.designPressureTop;

            // ADMISSIBLE STRESS @ DESIGN TEMPERATURE
            if (this.ellipsoidalHeadPressConcaveCalculator.rangeDesignTemperature === "TEMPERATURE OVER MATERIAL LIMIT") {
                this.ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp = "...";
            } else {
                // Buscar passando id do material
                const chaveGrausCelsiusBuscada = this.ellipsoidalHeadPressConcaveCalculator.designTemperature;

                try {
                    const resultado = await this.buscarCampoAdmissibleStressDatabaseASMEII(
                        this.ellipsoidalHeadPressConcaveCalculator.materialSpecification,
                        chaveGrausCelsiusBuscada
                    );

                    this.ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp = resultado;

                } catch (error) {
                    console.error("Erro ao buscar admissibleStressDesignTemp:", error);
                }
            }

            // ADMISSIBLE STRESS @ ROOM TEMPERATURE 
            try {
                const resultado = await this.buscarCampoAdmissibleStressDatabaseASMEII(
                    this.ellipsoidalHeadPressConcaveCalculator.materialSpecification,
                    "37,78"
                );
                this.ellipsoidalHeadPressConcaveCalculator.admissibleStressRoomTemp = resultado;
            } catch (error) {
                console.error("Erro ao buscar admissibleStressRoomTemp:", error);
            }

            // INSIDE RADIUS
            this.ellipsoidalHeadPressConcaveCalculator.insideRadius = this.ellipsoidalHeadPressConcaveCalculator.insideDiameter / 2;

            // CORROSION ALLOWANCE
            this.ellipsoidalHeadPressConcaveCalculator.corrosionAllowance = this.designData.corrosionAllowance;

            // LENGTH (SEE IN DRAWING) CORRODED
            this.ellipsoidalHeadPressConcaveCalculator.lengthCorroded = this.converterParaFloat(this.ellipsoidalHeadPressConcaveCalculator.length) + this.ellipsoidalHeadPressConcaveCalculator.corrosionAllowance;

            // INSIDE RADIUS CORRODED
            this.ellipsoidalHeadPressConcaveCalculator.insideRadiusCorroded = (this.ellipsoidalHeadPressConcaveCalculator.insideDiameter / 2) + this.ellipsoidalHeadPressConcaveCalculator.corrosionAllowance;

            // FACTOR FOR ELLIPSIODAL HEADS (D/2h)
            this.ellipsoidalHeadPressConcaveCalculator.factorForEllipsiodalHeads =
            ((1 / 6) *
            (2 + Math.pow(
                this.converterParaFloat(this.ellipsoidalHeadPressConcaveCalculator.insideRadiusCorroded) /
                this.converterParaFloat(this.ellipsoidalHeadPressConcaveCalculator.lengthCorroded),
                2
            ))).toFixed(2);

            // NOMINAL THICKNESS minus Corrosion Allowance
            this.ellipsoidalHeadPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance = this.ellipsoidalHeadPressConcaveCalculator.nominalThickness - this.ellipsoidalHeadPressConcaveCalculator.corrosionAllowance;

            // VALID OU INVALID NOMINAL THICKNESS
            if(this.ellipsoidalHeadPressConcaveCalculator.nominalThickness < this.ellipsoidalHeadPressConcaveCalculator.designThickness){
                this.ellipsoidalHeadPressConcaveCalculator.validNominalThickness = false;
                }
            else {
                this.ellipsoidalHeadPressConcaveCalculator.validNominalThickness = true;
            }

            // -- PARTE 2 - DESIGN VALIDATION -- //

            // DESIGN THICKNESS
            if(this.ellipsoidalHeadPressConcaveCalculator.weldedJointEfficiency === "NA"){
                this.ellipsoidalHeadPressConcaveCalculator.weldedJointEfficiency = 1.0;
            }
            this.ellipsoidalHeadPressConcaveCalculator.designThickness = (this.ellipsoidalHeadPressConcaveCalculator.designPressure * this.ellipsoidalHeadPressConcaveCalculator.insideRadiusCorroded * this.ellipsoidalHeadPressConcaveCalculator.factorForEllipsiodalHeads) / (this.ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp * this.ellipsoidalHeadPressConcaveCalculator.weldedJointEfficiency - (0.1 * this.ellipsoidalHeadPressConcaveCalculator.designPressure)) + this.ellipsoidalHeadPressConcaveCalculator.corrosionAllowance;

            this.ellipsoidalHeadPressConcaveCalculator.designThickness = this.ellipsoidalHeadPressConcaveCalculator.designThickness.toFixed(3);

            // WORKING MAXIMUM ALLOWABLE PRESSURE CORRODED AND HOT

            if(this.ellipsoidalHeadPressConcaveCalculator.validNominalThickness === false){
                this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure = "INVALID NOMINAL THICKNESS";
            }
            else if(this.ellipsoidalHeadPressConcaveCalculator.nominalThickness === 0){
                this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure = 0;
            }
            else {
                this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure = this.ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp * this.ellipsoidalHeadPressConcaveCalculator.weldedJointEfficiency * this.ellipsoidalHeadPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance / (this.ellipsoidalHeadPressConcaveCalculator.factorForEllipsiodalHeads * this.ellipsoidalHeadPressConcaveCalculator.insideRadiusCorroded + (0.1 * this.ellipsoidalHeadPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance));
            }

            this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure = this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure.toFixed(3);

            // HIDROSTATIC TEST PRESSURE
            if(this.ellipsoidalHeadPressConcaveCalculator.validNominalThickness === false){
                this.ellipsoidalHeadPressConcaveCalculator.hidrostaticTestPressure = "INVALID NOMINAL THICKNESS";
            }
            else{
                this.ellipsoidalHeadPressConcaveCalculator.hidrostaticTestPressure = (1.3 * this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure * (this.ellipsoidalHeadPressConcaveCalculator.admissibleStressRoomTemp / this.ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp)).toFixed(3);
            }

            // PNEUMATIC TEST PRESSURE
            if(this.ellipsoidalHeadPressConcaveCalculator.validNominalThickness === false){
                this.ellipsoidalHeadPressConcaveCalculator.pneumaticTestPressure = "INVALID NOMINAL THICKNESS";
            }
            else{
                this.ellipsoidalHeadPressConcaveCalculator.pneumaticTestPressure = (1.1 * this.ellipsoidalHeadPressConcaveCalculator.workingMaximumAllowablePressure * (this.ellipsoidalHeadPressConcaveCalculator.admissibleStressRoomTemp / this.ellipsoidalHeadPressConcaveCalculator.admissibleStressDesignTemp)).toFixed(3);
            }
        },
        converterParaFloat(valor) {
            if (valor === "" || valor === null || valor === undefined) {
                return 0;
            }

            const valorString = valor.toString().trim();
            const valorSemEspacos = valorString.replace(/\s+/g, "");
            let valorNormalizado = valorSemEspacos;

            if (valorSemEspacos.includes(",") && valorSemEspacos.includes(".")) {
                const ultimoPonto = valorSemEspacos.lastIndexOf(".");
                const ultimaVirgula = valorSemEspacos.lastIndexOf(",");
                const separadorDecimal = ultimaVirgula > ultimoPonto ? "," : ".";
                const separadorMilhar = separadorDecimal === "," ? "." : ",";

                valorNormalizado = valorSemEspacos
                    .replace(new RegExp(`\\${separadorMilhar}`, "g"), "")
                    .replace(separadorDecimal, ".");
            } else if (valorSemEspacos.includes(",")) {
                valorNormalizado = valorSemEspacos.replace(/,/g, ".");
            }

            const valorConvertido = parseFloat(valorNormalizado);
            return isNaN(valorConvertido) ? 0 : valorConvertido;
        },
    },
};
</script>

<style>
.material-table {
    overflow: visible !important;
}

.material-options {
    max-height: 280px;
    overflow-y: auto;
    overflow-x: hidden;
    top: 100%;
    left: 0;
    z-index: 9999;
    border: 1px solid #d7e0ed;
    border-radius: 8px;
    box-shadow: 0 10px 24px rgba(23, 32, 51, 0.14);
}

.material-option {
    cursor: pointer;
    color: #334e73;
    padding: 11px 14px;
    white-space: normal;
}

.material-option:hover,
.material-option:focus {
    background-color: #edf4ff;
    color: #0056ff;
}
</style>